<template>
  <v-sheet
    class="px-3 mx-auto"
    color="transparent"
    max-width="960px"
    width="100%"
  >
    <template v-if="isLoading">
      <v-card class="mt-6 mt-sm-7 form-card">
        <div class="d-flex align-center">
          <v-progress-circular indeterminate size="20" color="red" />

          <div class="text-h6 font-weight-medium ml-3">Carregando...</div>
        </div>
      </v-card>
    </template>

    <template v-else>
      <TitleFormWidget class="mt-6" icon="cog" :title="title" />

      <v-form @submit.prevent="submit" class="mt-3 mt-sm-4" ref="form">
        <v-card class="form-card">
          <div class="grid-list grid-list-4-columns">
            <TextFarmField
              v-model="item.name"
              class="span2"
              placeholder="Nome de apresentação do sistema"
              title="Nome"
            />

            <TextFarmField
              v-model="item.title"
              class="span2"
              title="Título do site (SEO)"
            />

            <TextareaFarmField
              v-model="item.description"
              title="Descrição do site (SEO)"
              class="span4"
            />
          </div>
        </v-card>

        <v-sheet class="mt-6 mt-sm-8 fixed-bottom" color="#f7f8fa">
          <v-divider />

          <div class="d-flex justify-end py-4 px-6">
            <v-btn
              class="rounded-lg ml-2"
              color="orange"
              type="submit"
              depressed
            >
              <v-icon color="white" size="20">mdi-content-save</v-icon>
              <div
                class="white--text text-body-1 text-none font-weight-medium ml-2"
              >
                Salvar Alterações
              </div>
            </v-btn>
          </div>
        </v-sheet>
      </v-form>
    </template>

    <v-dialog
      v-if="dialogToGoBack"
      v-model="dialogToGoBack"
      max-width="500"
      persistent
    >
      <ToGoBackDialog @close="dialogToGoBack = !dialogToGoBack" />
    </v-dialog>
  </v-sheet>
</template>

<script>
import TitleFormWidget from "@/components/widgets/TitleForm.vue";
import TextFarmField from "@/components/fields/farm/Text.vue";
import TextareaFarmField from "@/components/fields/farm/Textarea.vue";
import ToGoBackDialog from "@/components/dialogs/ToGoBack.vue";
import { mapActions } from "vuex";

export default {
  components: {
    TitleFormWidget,
    TextFarmField,
    TextareaFarmField,
    ToGoBackDialog,
  },
  data: () => ({
    isLoading: false,
    isLoadingInsert: false,
    dialogToGoBack: false,
    item: {
      name: null,
      title: null,
      description: null,
      logotipo: null,
      favicon: null,
      initial_year: null,
    },
  }),
  computed: {
    title() {
      return "Configurações";
    },
  },
  methods: {
    ...mapActions("config", ["getConfig", "updateConfig"]),
    async submit() {
      this.isLoadingInsert = false;

      const form = new FormData(this.$refs.form);
      const r = await this.updateConfig(form);

      if (r) {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-cog-sync",
          message: "Configurações salvas com sucesso.",
          type: "success",
        });
      } else {
        this.$eventHub.$emit("snackBar", {
          icon: "mdi-cog-off",
          message: "Não foi possível salvar as configurações. Tente novamente.",
          type: "error",
        });
      }

      this.isLoadingInsert = false;
    },
  },
  async mounted() {
    this.isLoading = true;
    const r = await this.getConfig();

    if (r) {
      this.item = r;
    }

    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
.form-card {
  border: 1px solid #e5e5e5 !important;
  border-radius: 14px !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1) !important;
  padding: 24px;
}

.grid-list {
  display: grid;
  gap: 12px;
}

.grid-list-4-columns {
  grid-template-columns: repeat(4, 1fr);
}

.span2 {
  grid-column: span 2;
}

.span3 {
  grid-column: span 3;
}

.span4 {
  grid-column: span 4;
}

.fixed-bottom {
  bottom: 0;
  margin-left: -12px;
  margin-right: -12px;
  position: sticky;
}
</style>
